import firebase from 'firebase/app'
import 'firebase/functions'

export const fetchTeamAdvances = async ({ teamId = null, groupId = null, start, end, competence = false }) => {
    const fn = firebase.functions().httpsCallable('httpStats-getTeamAdvances')
    const { data } = await fn({ teamId, groupId, start, end, competence })
    const map = new Map()
    ;(data?.advances || []).forEach(a => { if (a?.id) map.set(a.id, { advance: a.advance || null, studentId: a.studentId || null }) })
    return map
}

export const fetchGroupAdvances = async ({ teamId = null, groupId = null, start, end, competence = false }) => {
    const fn = firebase.functions().httpsCallable('httpStats-getTeamAdvances')
    const { data } = await fn({ teamId, groupId, start, end, competence })
    return (data?.advances || []).filter(a => a?.id)
}

export const fetchStudentsAdvances = async ({ coachId = null, teamId = null, groupId = null, studentIds = null, start, end, competence = false }) => {
    const fn = firebase.functions().httpsCallable('httpStats-getStudentsAdvances')
    const payload = { start, end, competence }
    if (teamId) payload.teamId = teamId
    else if (groupId) payload.groupId = groupId
    else {
        payload.coachId = coachId
        payload.studentIds = studentIds || []
    }
    const { data } = await fn(payload)
    return data?.advances || []
}

export const fetchCoachWeeklyRoutines = async (coachId) => {
    if (!coachId) return 0
    const fn = firebase.functions().httpsCallable('httpStats-getCoachWeeklyRoutines')
    const { data } = await fn({ coachId })
    return Number(data?.count || 0)
}

export const fetchEvaluationSummaries = async ({ coachId, assignedEvaluationIds = [] }) => {
    const fn = firebase.functions().httpsCallable('httpStats-getEvaluationSummaries')
    const { data } = await fn({ coachId, assignedEvaluationIds })
    return data?.summaries || []
}

export const getScopeDocs = (docs, studentIds = null) => {
    if (!studentIds || !studentIds.length) return docs || []

    const ids = new Set(studentIds)
    return (docs || []).map(doc => {
        const assignedRoutines = (doc?.assignedRoutines || []).filter(routine => ids.has(routine.student?.objectID))
        if (!assignedRoutines.length) return null
        return {
            ...doc,
            assignedRoutines,
            advance: ids.size === 1 ? (assignedRoutines[0].advance || null) : averageAdvance(assignedRoutines),
        }
    }).filter(Boolean)
}

const averageAdvance = (assignedRoutines) => {
    const preSum = {}
    const postSum = {}
    let preCount = 0
    let postCount = 0

    assignedRoutines.forEach(({ advance }) => {
        if (!advance) return
        if (advance.pre && advance.preInfo) {
            Object.entries(advance.preInfo).forEach(([key, value]) => {
                if (typeof value === 'number') preSum[key] = (preSum[key] || 0) + value
            })
            preCount++
        }
        if (advance.post && advance.postInfo) {
            Object.entries(advance.postInfo).forEach(([key, value]) => {
                if (key === 'comment') return
                postSum[key] = (postSum[key] || 0) + Number(value || 0)
            })
            postCount++
        }
    })

    const average = (sum, count) => {
        const result = {}
        Object.keys(sum).forEach(key => { result[key] = +(sum[key] / count).toFixed(1) })
        return result
    }

    return {
        pre: preCount > 0,
        preInfo: preCount > 0 ? average(preSum, preCount) : null,
        post: postCount > 0,
        postInfo: postCount > 0 ? average(postSum, postCount) : null,
    }
}

